import NiceModal, { useModal } from "@ebay/nice-modal-react";
import clsx from "clsx";
import { memo } from "react";
import ReactModal from "react-modal";

import Button from "components/Button";

interface Props {
  title?: string;
  message: string;
  showCancel?: boolean;
  cancelText?: string;
  submitText?: string;
}

const Simple = ({
  title,
  message,
  showCancel = true,
  cancelText = "취소",
  submitText = "확인",
}: Props) => {
  const modal = useModal();

  const closeModal = () => {
    modal.reject();
    modal.hide();
  };

  const onConfirm = () => {
    modal.resolve();
    modal.hide();
  };

  return (
    <ReactModal
      overlayClassName="overflow-auto flex fixed size-full top-0 left-0 z-30"
      className="bg-[rgba(0,0,0,0.2)] min-w-[1280px] min-h-[720px] flex justify-center items-center size-full outline-none"
      isOpen={modal.visible}
      onRequestClose={closeModal}
      onAfterClose={() => {
        modal.remove();
      }}
    >
      <div className="bg-white w-[28.125rem] pb-6 pt-7 px-[3.125rem] rounded-md border-[0.5px] border-[rgba(102,112,128,0.5)]">
        {!!title && <p className="font-bold text-18 text-center">{title}</p>}
        <div className="min-h-[7.625rem] flex items-center pb-1">
          <p className="whitespace-pre-wrap text-center w-full">{message}</p>
        </div>
        <div
          className={clsx("flex gap-2", {
            "w-[50%] mx-auto": !showCancel,
          })}
        >
          <Button className="flex-1" outline={showCancel} onClick={onConfirm}>
            {submitText}
          </Button>
          {showCancel && (
            <Button className="flex-1" onClick={closeModal}>
              {cancelText}
            </Button>
          )}
        </div>
      </div>
    </ReactModal>
  );
};

const SimpleModal = NiceModal.create(memo(Simple));
SimpleModal.displayName = "SimpleModal";

export default SimpleModal;
